import React, { useState } from "react";
import { ApprovePayout } from "../../pages";
import { object, string } from "yup";
import { PayoutController } from "../../controllers";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";

const ApprovePayoutContainer = ({ closeModal, mappedTags }) => {
  const [loading, setLoading] = useState(false);
  const validationSchema = () => {
    return object({
      comment: string().required("Please enter comment"),
    });
  };

  const tag = mappedTags?.[0].tag;
  const tagStatus = mappedTags?.[0].status;

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      tag: tag,
      comment: values.comment,
    };
    if (tagStatus === "APPROVED") {
      MimaToastUtil.error({
        message: "Payout already approved",
      });
    } else if (tagStatus === "IGNORED") {
      MimaToastUtil.error({
        message: "Cannot approve ignored payout",
      });
    } else {
      const { status, errorMessage } =
        await PayoutController.approvePayout(payload);
      setLoading(false);
      if (status === constant.Success) {
        MimaToastUtil.success({
          message: constant.Success,
        });
        return closeModal();
      }
      MimaToastUtil.error({
        message: errorMessage,
      });
    }
    return closeModal();
  };

  return (
    <ApprovePayout
      closeModal={closeModal}
      validationSchem={validationSchema}
      loading={loading}
      onSubmit={onSubmit}
    />
  );
};

export default ApprovePayoutContainer;
